import { useTranslation } from "react-i18next";
import Button from "../../Button/Button";
import IconButton from "../../IconButton/IconButton";
import styles from "../TransparentDrawer.module.scss";
import { useNavigate } from "react-router-dom";

function PaymentError() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className={styles.paymentButtonsGroupWrapper}>
      <div className={styles.paymentButtonsGroupHeader}>
        <IconButton
          iconName=""
          onClick={() => {}}
          color="primary"
          variant="text"
        />
        <p
          className={`body-bold-large ${styles.paymentButtonsGroupTitle} ${styles.paymentErrorTitle}`}
        >
          {t("transparentDrawer.title.paymentError")}
        </p>
        <IconButton
          iconName=""
          onClick={() => {}}
          color="primary"
          variant="text"
        />
      </div>
      <div className={styles.paymentDescriptionContent}>
        <p className={`body-bold-medium ${styles.paymentDescription}`}>
          {t("paymentError.title")}
        </p>
        <p className={`body-medium ${styles.paymentDescription}`}>
          {t("paymentError.description")}
        </p>
      </div>
      <Button
        onClick={() => navigate(-1)}
        label={t("transparentDrawer.button.changePaymentMethod")}
        variant="contained"
        color="primary"
        maxWidth
        mobile={true}
      />
    </div>
  );
}

export default PaymentError;
